import { ConfigProvider, message } from 'antd';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import ToastViewport from './reusable/Toast/Toast';
import IntercomChat from './layout/IntercomChat';
import I18nProvider from './i18n/I18nProvider';
import AppRouter from './router/router';
import { persistor, store } from './store/store';

// antd's `message` pops up 8px from the top — over the top bar. Start it below
// the bar instead, where the app's own toasts sit (20px shell padding + the
// 40px bar + 12px; see Toast.scss).
message.config({ top: 72 });

export default function App() {
  // No antd theme: every antd component we use is styled locally, so a global
  // theme would only be another place for the Figma values to drift from.
  // `wave` is behaviour, not theming — no design in the file has a click ripple.
  return (
    <Provider store={store}>
      {/* `loading={null}` on purpose — rehydrating from localStorage is a single
          synchronous read, and a spinner for it would just flash. */}
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider wave={{ disabled: true }}>
          {/* The app's own translations (src/locales) — switching language
              re-mounts what's inside, so it renders again in that language. */}
          <I18nProvider>
            <AppRouter />
            {/* Mounted once — `toast.*` from any page renders through here. */}
            <ToastViewport />
          </I18nProvider>
          {/* The support chat on every page, as on the live dashboard (N79). */}
          <IntercomChat />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
}
